import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-siyavr-ram',
  templateUrl: './siyavr-ram.component.html',
  styleUrls: ['./siyavr-ram.component.scss']
})
export class SiyavrRamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
